export enum MenuOrientation {
  STATIC,
  OVERLAY,
  HORIZONTAL,
}
